import { VideoState } from './video.types';
import { atom } from 'jotai';

// --------------------------------------------------------------------------
export const VideoAtom = atom<Record<string, VideoState | undefined>>({});
